module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container_wrap"
  }, [(_vm.NewsItemData && _vm.NewsItemData.pics && _vm.NewsItemData.pics.length > 0) ? _c('div', {
    staticClass: "left_img"
  }, [(_vm.specialTagName == '推荐') ? _c('div', {
    staticClass: "img_flag img_flag_recommond"
  }, [_vm._v("\n        推荐\n      ")]) : (_vm.specialTagName == '最新') ? _c('div', {
    staticClass: "img_flag img_flag_new"
  }, [_vm._v("\n        最新\n      ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.NewsItemData && _vm.NewsItemData.pics && _vm.NewsItemData.pics[0].url ?
        _vm.NewsItemData.pics[0].url :
        '#',
      "alt": "新闻图片"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right_content"
  }, [_c('div', {
    staticClass: "right_content_title",
    style: (_vm.specialTagName == '推荐' ? 'color:#1981FF' : '')
  }, [_vm._v("\n        " + _vm._s(_vm.NewsItemData.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "right_content_subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.NewsItemData.desc) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "right_content_operations"
  }, [_c('div', {
    staticClass: "operations_common operations_date"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n            " + _vm._s(_vm._f("yearForm")(_vm.NewsItemData.update_time)) + "年" + _vm._s(_vm._f("monthForm")(_vm.NewsItemData.update_time)) + "月" + _vm._s(_vm._f("dayForm")(_vm.NewsItemData.update_time)) + "日\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "operations_common operations_seenum"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n            " + _vm._s(_vm.NewsItemData.views_count) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "operations_common operations_hotnum"
  }, [_c('div', {
    staticClass: "operations_common_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "operations_common_num"
  }, [_vm._v("\n            " + _vm._s(_vm.NewsItemData.views_count) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1b6c3aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainindex/NewsListItem2.vue
// module id = 1548
// module chunks = 0